import * as types from "./../../action-types";
import axios from "axios";
import { get, isEmpty, isNil, forEach } from "lodash";

async function loadCellularData({ state }, { customerID, locations }) {
  try {
    const response = await axios.get(
      `/v2/customers/${customerID}/locations/cellular_usage?${locations}`
    );
    return response;
  } catch (error) {
    throw error;
  }
}

async function loadLocations(
  { state, commit },
  { customerId, page = 1, pageSize = 5 }
) {
  try {
    const response = await axios.get(
      `v2/customers/${customerId}/locations?page=${page}&page_size=${pageSize}`
    );

    forEach(response.data.locations.invalid_kinds, (kind) => {
      if (
        response.data.locations.location_devices &&
        response.data.locations.location_devices.length
      ) {
        response.data.locations.location_devices =
          response.data.locations.location_devices.filter(
            (device) => device.type !== kind
          );
      }
      if (
        response.data.locations.devices &&
        response.data.locations.devices.length
      ) {
        response.data.locations.devices =
          response.data.locations.devices.filter(
            (device) => device.type !== kind
          );
      }
      forEach(response.data.locations.location_users, (loc_user) => {
        forEach(loc_user.devices, (device) => {
          loc_user.devices = loc_user.devices.filter(
            (device) => device.type !== kind
          );
        });
      });
    });

    commit(types.FETCH_ACCOUNT_LOCATIONS.SUCCESS, response.data.locations);
    commit(
      `db/devices/${types.FETCH_DEVICE_LIST.SUCCESS}`,
      get(response, "data.locations.devices", []),
      { root: true }
    );
    return response.data;
  } catch (error) {
    commit(types.FETCH_ACCOUNT_LOCATIONS.ERROR, error.data);
    throw error.statusText;
  }
}

async function addUser({ state, commit }, authorization) {
  let auth = {
    role: authorization.role,
    doorbot_id: authorization.doorbot_id,
    user_id: authorization.user_id,
  };
  try {
    const response = await axios.post(`v2/locations/add_user`, { auth: auth });
    commit(types.ADD_DEVICE_USER.SUCCESS, {
      user_id: auth.user_id,
      device: {
        doorbot_id: authorization.doorbot_id,
        role: "shared_user",
        type: authorization.type,
        location_id: authorization.location_id,
      },
    });
    return response;
  } catch (error) {
    throw error.data.error;
  }
}

async function removeUser({ state, commit }, authorization) {
  const location_id = authorization.location_id;

  let auth = {
    doorbot_id: authorization.doorbot_id,
    user_id: authorization.user_id,
  };
  try {
    const response = await axios.post(`v2/locations/remove_user`, {
      auth: auth,
    });
    commit(types.REMOVE_DEVICE_USER.SUCCESS, {
      user_id: auth.user_id,
      device_id: auth.doorbot_id,
      location_id,
    });
    return response;
  } catch (error) {
    throw error.data.error;
  }
}

async function setLocationAuthorizedUsers(
  { state, commit },
  { locationId, authorizedUsers }
) {
  try {
    // Create a custom type since it's not defined in action-types.js
    commit("SET_LOCATION_AUTHORIZED_USERS", { locationId, authorizedUsers });
    return true;
  } catch (error) {
    console.error("Error setting location authorized users:", error);
    throw error;
  }
}

export default {
  loadLocations,
  loadCellularData,
  addUser,
  removeUser,
  setLocationAuthorizedUsers,
};
